import React, { useEffect, useCallback } from 'react'

const useOutsideClick = ({
  innerRef,
  outerRef,
  callback,
  useHooks,
}: {
  innerRef: React.RefObject<HTMLElement>
  outerRef?: React.RefObject<HTMLElement>
  callback: (e?: TouchEvent | MouseEvent) => void
  useHooks: boolean
}): void => {
  const handleClick = useCallback(
    (e: MouseEvent | TouchEvent) => {
      if (!(e.target instanceof Node)) {
        return
      }

      if (outerRef?.current?.contains(e.target)) {
        return
      }

      if (innerRef.current && !innerRef.current.contains(e.target)) {
        callback(e)
      }
    },
    [callback, innerRef, outerRef],
  )

  useEffect(() => {
    if (useHooks) {
      document.addEventListener('mousedown', handleClick)
    }

    return () => {
      if (useHooks) {
        document.removeEventListener('mousedown', handleClick)
      }
    }
  }, [useHooks, handleClick])
}

export default useOutsideClick
